module.exports = __webpack_public_path__ + "static/media/an.9922af53.jpeg";